import React, { JSX } from 'react';
import { NavigateFunction } from "react-router-dom";
import { AppConstant } from '../constant/AppConstant';
import { OrderStatusEnum } from '../constant/OrderStatusEnum';
import { PaymentModeEnum } from '../constant/PaymentModeEnum';

let navigate: NavigateFunction;

export const setNavigate = (nav: NavigateFunction) => {
    navigate = nav;
};

export const getNavigate = () => navigate;

export const capitalizeString = (str: string) =>
    str.replace(/\b\w/g, char => char.toUpperCase());


export function showLog(message?: any, ...optionalParams: any[]): void {
    console.log(message, ...optionalParams);
}

export const getStatusOptions = () => [
    { label: "Active", value: "true" },
    { label: "Inactive", value: "false" }
];

export const getProductTypeOptions = () => [
    { label: "Food", value: "1" },
    { label: "Super Market", value: "2" }
];

export const getAvailableOptions = () => [
    { label: "Available", value: "true" },
    { label: "Unavailable", value: "false" }
];

export const getSimpleOptions = () => [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" }
];

export const formatDate = (isoString: string): string => {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
        return "-";//"Invalid Date";
    }

    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

export const formatUtcToLocalTime = (utcString: string): string => {
    try {
        const date = new Date(utcString);

        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: userTimeZone, // explicitly browser timezone
        });
    } catch (error) {
        console.error("Invalid UTC date:", error);
        return "";
    }
};

export const DetailsRow = ({ title, value }: { title: string; value: any }) => {
    const displayValue =
        value === undefined || value === "" || value === null ? " -- " : value;

    return (
        <div className="custom-details-row">
            <span className="custom-personal-row-title">{title}</span>
            <span className="custom-personal-row-value">{displayValue}</span>
        </div>
    );
};

export const statusCell = (value: string | boolean | undefined) => {
    return (
        <span className={`custom-status-${value ? "active" : "inactive"}`}>
            {value ? "Active" : "Inactive"}
        </span>
    );
};

export const checkCell = (value: string | boolean | undefined) => {
    return (
        <span className={`custom-status-${value ? "active" : "inactive"}`}>
            {value ? "Yes" : "No"}
        </span>
    );
};

export const availableCell = (value: string | boolean | undefined) => {
    return (
        <span className={`custom-status-${value ? "active" : "inactive"}`}>
            {value ? "Available" : "Unavailable"}
        </span>
    );
};

export const paymentCell = (value: string | boolean | undefined) => {
    return (
        <span className={`custom-status-${value ? "active" : "inactive"}`}>
            {value ? "Paid" : "Unpaid"}
        </span>
    );
};

export const imageCell = (field: string) => {
    return ({ row }: { row: { original: Record<string, any> } }) => {
        const value = row.original?.[field];

        return (
            <img
                src={`${AppConstant.IMAGE_BASE_URL}${value}?t=${Date.now()}`}
                alt="image"
                height="32"
                style={{ marginRight: '8px' }}
            />
        );
    };
};

export const priceCell = (value: string | number | undefined) => {
    return (
        <span>
            {value !== undefined && value !== null ? `${AppConstant.currencySymbol}${value}` : "-"}
        </span>
    );
};

export const orderStatusCell = (field: string) => {
    return ({ row }: { row: { original: Record<string, any> } }) => {
        const value = row.original?.[field];

        const status = OrderStatusEnum.get(value ?? -1)?.label || "-";

        const color = getStatusColor(value);

        return (
            <span style={{ color }}>
                {status}
            </span>
        );
    };
};


export const paymentModeCell = (field: string) => {
    return ({ row }: { row: { original: Record<string, any> } }) => {
        const value = row.original?.[field];

        const status = PaymentModeEnum.get(Number(value) ?? -1)?.label || "-";

        return (
            <span>
                {status}
            </span>
        );
    };
};

export const categoryCell = (field: string) => {
    return ({ row }: { row: { original: Record<string, any> } }) => {
        const value = row.original?.[field];
        const category = getProductTypeOptions().find(opt => opt.value === String(value))?.label || "-";

        return (
            <span>
                {category}
            </span>
        );
    };
};

export const getStatusColor = (value: number) => {
    let color = "";
    if (value === 1) {
        color = "var(--btn-pending)";
    } else if (value === 2) {
        color = "var(--btn-info)";
    } else if (value === 3) {
        color = "var(--btn-success)";
    }
    else if (value === 4) {
        color = "var(--btn-danger)";
    }
    return color;
}

export const descCell = (field: string) => {
    return ({ row }: { row: { original: Record<string, any> } }): JSX.Element => {
        const value = row.original?.[field];

        return (
            <div
                style={{
                    //   width: "200px",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                {value !== undefined && value !== null ? value : "-"}
            </div>
        );
    };
};
